import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkLoginStatus, selectUserInfo, getApiBaseUrl } from '../redux/WithcookieSlice';
import { useTranslation } from '../redux/TranslationHelper';
import axios from 'axios';

const RecommendedUsersComponent = ({ 
  style,
  content = {},
  data = {},
  componentProps = {},
  pathVariables = {}
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo);
  const { t } = useTranslation();
  const apiBaseUrl = useSelector(getApiBaseUrl);
  
  const [recommendedUsers, setRecommendedUsers] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const limit = 10; // 페이지당 표시할 항목 수

  // 스타일 설정
  const defaultStyle = {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Noto Sans KR, sans-serif',
    maxWidth: '800px',
    margin: '20px auto',
    position: 'relative',
    ...style
  };

  // 추천 유저 목록 조회
  useEffect(() => {
    const fetchRecommendedUsers = async () => {
      if (!userInfo) return;
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await axios.get(`${apiBaseUrl}/api/users/recommended-users`, {
          params: {
            page: currentPage,
            limit: limit
          },
        });
        
        setRecommendedUsers(response.data['recommended-users'] || []);
        setTotalCount(response.data.totalCount);
      } catch (err) {
        setError(t('추천 유저 목록을 불러오는데 실패했습니다.'));
        console.error('Error fetching recommended users:', err);
      } finally {
        setLoading(false);
      }
    };
    
    fetchRecommendedUsers();
  }, [userInfo, currentPage, apiBaseUrl, t]);

  // 페이지 변경 핸들러
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // 로딩 상태 또는 로그인 안 된 경우 처리
  if (!userInfo) {
    return (
      <div style={defaultStyle}>
        <h2 style={{ marginTop: 0, marginBottom: '20px', textAlign: 'center' }}>{t('피추천인 목록')}</h2>
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>{t('로그인이 필요합니다.')}</p>
        </div>
      </div>
    );
  }

  return (
    <div style={defaultStyle}>
      <h2 style={{ marginTop: 0, marginBottom: '20px', textAlign: 'center' }}>{t('피추천인 목록')}</h2>
      
      {loading && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <p>{t('로딩 중...')}</p>
        </div>
      )}
      
      {error && (
        <div style={{ color: '#dc3545', textAlign: 'center', padding: '20px' }}>
          <p>{error}</p>
        </div>
      )}
      
      {!loading && !error && (
        <>
          <div style={{ marginBottom: '20px' }}>
            <p style={{ textAlign: 'right', color: '#666' }}>
              {t('총')} {totalCount} {t('명')}
            </p>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            {recommendedUsers.map((user) => (
              <div 
                key={user.id}
                style={{
                  padding: '15px',
                  borderBottom: '1px solid #eee',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}
              >
                <div>
                  <p style={{ margin: 0, fontWeight: 'bold' }}>{user.insungId} ({user.name})</p>
                  <p style={{ margin: '5px 0 0', color: '#666', fontSize: '0.9em' }}>
                    {new Date(user.createdAt).toLocaleDateString('ko-KR')}
                  </p>
                </div>
              </div>
            ))}
          </div>
          
          {totalCount > limit && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '20px',
              gap: '6px'
            }}>
              {Array.from({ length: Math.ceil(totalCount / limit) }, (_, i) => (
                <button
                  key={i}
                  onClick={() => handlePageChange(i + 1)}
                  style={{
                    padding: '8px 14px',
                    border: currentPage === i + 1 ? 'none' : '1px solid #e2e8f0',
                    backgroundColor: currentPage === i + 1 ? '#3b82f6' : 'white',
                    color: currentPage === i + 1 ? 'white' : '#64748b',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '0.875rem',
                    fontWeight: currentPage === i + 1 ? '600' : '400',
                    boxShadow: currentPage === i + 1 ? '0 2px 4px rgba(59, 130, 246, 0.3)' : 'none',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {i + 1}
                </button>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default RecommendedUsersComponent; 